export default "__VITE_ASSET__861178a2__"